// extracted by mini-css-extract-plugin
export var cardContainer = "styles-module--cardContainer--cbd42";
export var category = "styles-module--category--16730";
export var excerpt = "styles-module--excerpt--34979";
export var image = "styles-module--image--edbcb";
export var latest = "styles-module--latest--245bf";
export var link = "styles-module--link--ba064";
export var sideBar = "styles-module--sideBar--0f968";
export var threeCols = "styles-module--threeCols--936d7";
export var title = "styles-module--title--2821f";